import Confirm from 'app/confirm/components/confirm';
import FormDialog from 'app/form-dialog/components/form-dialog';
import AgentEvalRunEdit from '../agent/components/agent-eval-run-edit';

export const GlobalModals = () => {
  return (
    <>
      <Confirm />
      <FormDialog />
      <AgentEvalRunEdit />
    </>
  );
};
